/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
import WebFont from 'webfontloader'

export function loadFonts() {
  WebFont.load({
    google: {
      api: 'https://fonts.googleapis.com/css2',
      families: ['Inter:wght@300;400;500;600;700;900&display=swap'],
    },
  })
}

export default function () {
  loadFonts()
}
